import { createModuleBackedPlatformObservability } from "@orb-labs/orby-react";

export const webPlatformObservability = createModuleBackedPlatformObservability({
  error: (msg, ...args) => console.error(msg, ...args),
  warn: (msg, ...args) => console.warn(msg, ...args),
  isDev: import.meta.env.DEV,
});
